import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-16 max-sm:mt-12',
    tags: 'fex-wrap scrollbar-hidden mb-8 flex items-center gap-1 overflow-x-auto',
    tag: 'px-3',
    footer:
      'bg-bg-items-white flex justify-between gap-6 p-10 max-sm:flex-col max-sm:p-6 sm:items-center',
    footerButton: 'heading-s flex items-center gap-2',
    backIcon: 'size-6 rotate-180',
    share: 'block'
  }
});
